<template>
  <v-container fluid>
    <div class="md-card md-theme-default  rounded-5 bordered shadow-0 mt-0">
      <div class="md-card-content md-card-table">
        <div>
          <div class="d-flex justify-space-between align-center ">
            <SvgIcon class="text-2xl font-semibold" text="Deals"></SvgIcon>
            <v-spacer/>
            <v-select
                v-model="perPage"
                :items="[10, 15, 25, 50]"
                :menu-props="{ bottom: true, offsetY: true }"
                class="q-autocomplete shadow-0 m-r-3 mt-2"
                hide-details
                outlined
                @change="searchData"
                style="max-width: 120px"
                placeholder="Per Page"
                dense
            ></v-select>

            <v-text-field
                v-model="search"
                class="q-autocomplete shadow-0 m-r-3 mt-2"
                dense
                height="40"
                hide-details
                @keyup="searchFilter"
                outlined
                style="max-width: 240px"
                placeholder="Search Clients"
            >
              <template #prepend-inner>
                <SearchIcon/>
              </template>
            </v-text-field>
            <v-btn
                class="export-button mt-2"
                elevation="0"
                height="40"
                @click="dealsReportExcelDownload"
            >
              <SvgIcon text="Export">
                <template v-slot:icon>
                  <ExportIcon/>
                </template>
              </SvgIcon>
            </v-btn>
          </div>
          <br><br/>
          <div class="table-responsive">
            <table class="table border-collapse">
              <thead>
              <tr class="opacity-70 tr-neon tr-rounded ">
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Client Name</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Venue Name</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Sales Person</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Deals (AED)</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Start Date</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">End Date</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Installments</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Installment Amount</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Next Payment</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Attachments</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Contact</div>
                  </div>
                </th>
                <th>
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">Action</div>
                  </div>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(data, index) in deals" :key="index" class="border-bottom text-center">
                <td>
                  <div>
                    {{ data.client_name }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ data.venue? data.venue.name :"" }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ data.sales_person? data.sales_person.user.first_name+' '+ data.sales_person.user.last_name :"" }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ data.value_of_deal | toCurrency }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ data.contract_start_date | dateformat }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ data.contract_end_date | dateformat }}
                  </div>
                </td>
                <td>
                  <div @click="openSalesDealsInstallmentsPopup(data)">
                    <v-btn
                        style=""
                        class="download-button text_capitalize "
                        outlined
                    >
                      <div class="d-flex align-center gap-x-2">    {{ data.installments_count }}</div>
                    </v-btn>
                  </div>
                </td>
                <td>
                  <div>
                    {{parseFloat(data.installment_per_month)  |toCurrency}}
                  </div>
                </td>
                <td>
                  {{ data.upcoming_installment }}
                </td>
                <td>
                  <div>
                    <v-menu offset-y content-class="q-menu">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            style=""
                            class="download-button text_capitalize "
                            outlined
                            v-bind="attrs"
                            v-on="on"
                        >
                          <div class="d-flex align-center gap-x-2"> <FileDownloadIcon/> Files</div>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="downloadPdf(data.agreement_file)">
                          <v-list-item-title><div class="d-flex align-center gap-x-2"><DownloadIcon/> Agreement File</div> </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="downloadPdf(data.trade_license)">
                          <v-list-item-title><div class="d-flex align-center gap-x-2"><DownloadIcon/> Trade License</div></v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="downloadPdf(data.tax_certificate)">
                          <v-list-item-title><div class="d-flex align-center gap-x-2"><DownloadIcon/> Tax Certificate</div></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </td>
                <td>
                  <div>
                    <v-menu offset-y content-class="q-menu">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            text
                        >
                          <EditBtnIcon/>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="copyContent(data.contact_person_name)">
                          <v-list-item-title>Name: {{ data.contact_person_name }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="copyContent(data.contact_person_mobile)">
                          <v-list-item-title>Mobile: {{ data.contact_person_mobile }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="copyContent(data.contact_person_email)">
                          <v-list-item-title>Email: {{ data.contact_person_email }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </td>


                <td>
                  <div>
                    <v-menu offset-y content-class="q-menu">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            text
                        >
                          <EditBtnIcon/>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="editDeal(data.id)">
                          <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                      </v-list>

                    </v-menu>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <v-row>
      <v-col cols="4"></v-col>
      <v-col cols="4">
        <v-pagination v-model="page" :length="totalPages" class="new-pagination" total-visible="7"></v-pagination>
      </v-col>
      <v-col class="d-flex align-center justify-end" cols="4">
        <div class="d-flex align-center justify-end text-sm gap-x-2">
          <span class="">Result</span>
          <div style="width: 80px">
            <v-select
                v-model="perPage"
                :items="[10, 15, 25, 50]"
                :menu-props="{ bottom: true, offsetY: true }"
                class="q-autocomplete text-sm"
                flat
                hide-details
                solo
                @change="searchData"
            ></v-select>
          </div>
          <span>Per Page</span>
        </div>
      </v-col>
    </v-row>

    <SalesDealInstallmentPopup v-if="salesDealsInstallmentsPopup" :installmentDialog="salesDealsInstallmentsPopup" :dealId="salesTeamDealId" @closeInstallmentPopup="closeSalesDealsInstallmentsPopup" />

  </v-container>
</template>

<script>
import moment from "moment";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import ExportIcon from "@/assets/images/misc/export-icon.svg";
import EditBtnIcon from "@/assets/images/misc/options-icon.svg";
import FileDownloadIcon from "@/assets/images/misc/file-download-icon.svg";
import DownloadIcon from "@/assets/images/misc/download-icon.svg";
import SearchIcon from "@/assets/images/misc/search.svg";
import SalesDealInstallmentPopup from "@/views/SalesTeam/SalesDealInstallmentPopup.vue";

export default {
  props: {
    refreshData:{ type:Boolean, default:false},
    salesTeamId: {type: Number, default: 0},
    global: {
      type: Boolean,
      default: true,
    },

    exportPermission: {
      type: Boolean,
      default: false,
    },
  },
  components: {SalesDealInstallmentPopup, ExportIcon, SvgIcon, EditBtnIcon, SearchIcon, FileDownloadIcon,DownloadIcon},
  data() {
    return {
      search: null,
      deals: [],
      searchParams: {
        timestamp: [],
        status_id: null,
        start_date: moment()
            .subtract(30, "days")
            .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      },
      menu1: false,
      menu2: false,
      flag: false,
      timeDuration: [
        {name: "All", title: "All"},
        {name: "week", title: "This Week"},
        {name: "year", title: "This Year"},
        {name: "month", title: "This Month"},
        {name: "custom", title: "Custom Duration"},
      ],
      status_id: null,
      page: 1,
      totalPages: 1,
      perPage: 10,
      salesDealsInstallmentsPopup:false,
      salesDealInstallments:[],
      salesTeamDealId:null,
    };
  },
  watch: {
    refreshData() {
      this.searchData();
    },
    page() {
      this.searchData();
    },
  },
  computed: {
    date1Formatted() {
      return moment(this.searchParams.start_date, "YYYY-MM-DD").format(
          "Do MMM YYYY"
      );
    },
    date2Formatted() {
      return moment(this.searchParams.end_date, "YYYY-MM-DD").format(
          "Do MMM YYYY"
      );
    },
  },
  mounted() {
    this.status_id = [4, 5, 8, 17, 21, 22];
    this.columns = [];
    setTimeout(() => {
      this.searchData();
    }, 200)

    if (this.$store.getters.getCountries.status == false) {
      this.$store.dispatch("loadCountries");
    }
  },
  methods: {

    copyContent(data) {
      const el = document.createElement("textarea");
      el.value = data;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
          document.getSelection().rangeCount > 0
              ? document.getSelection().getRangeAt(0)
              : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.showInfo( "Copied to clipboard", 2000);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    downloadPdf(path) {
      window.open(this.s3BucketURL + path, "_blank");
    },
    searchFilter(){
      setTimeout(()=> {
        this.showLoader('Searching..');
        this.searchData()
        this.hideLoader();
      },300)
    },
    searchData() {
      let filters = '';
      if(this.search){
        filters += '&search='+this.search;
      }
      let url = `sales-team/deals?page=${this.page}&per_page=${this.perPage}`+filters
      if(this.salesTeamId){
        url = "sales-team/deals/" + this.salesTeamId + `?page=${this.page}&per_page=${this.perPage}`+filters;
      }
      this.$http({
        url: url,
        method: "GET",
      })
          .then((response) => {
            if (response.status === 200) {
              this.deals = response.data.data;
              this.deals.map((ele) => {
                ele.upcoming_installment = 'N/A';
                if (ele.installments && ele.installments.length > 0) {
                  ele.upcoming_installment = moment(ele.installments[0].installment_date, 'YYYY-MM-DD').format("Do MMM YYYY");
                }
              })
              this.totalPages = response.data.total_pages;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.hideLoader();
          });

    },
    dealsReportExcelDownload() {
      this.showLoader("Generating..");
      let url = 'sales-team/deals/export';
      if(this.salesTeamId){
        url = "sales-team/deals/export/" + this.salesTeamId;
      }
      this.$http.get(url, {
        responseType: "blob",
      })
          .then((response) => {
            if (response.status == 200) {
              this.downloadFile(response, `deals`);
              this.hideLoader();
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },

    editDeal(id){
      console.log('edit deal')
      this.$emit('openDealModal',{id:id})
    },
    openSalesDealsInstallmentsPopup(deal){
      this.salesTeamDealId = deal.id
      this.salesDealsInstallmentsPopup = true;
    },

    closeSalesDealsInstallmentsPopup(){
      this.salesDealsInstallmentsPopup = false;
      this.searchData();
    },

  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.salesBtn {
  padding: 5px;
  font-size: 14px;
  font-weight: bold;
  color: #066a8c;
}

.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}

.book_time_log {
  color: #066a8c;
}

.md-card-header tr th:nth-child(1) {
  text-align: left !important;
}

.search_customer .v-input {
  margin: 0 0px;
}

.headline_ticket {
  background: #000;
  color: #fff;
}

.head {
  text-align: center;
  margin: 0 auto;
}

.headTicket {
  color: gray;
  font-weight: bold;
}

.valueTicket {
  color: #fff;
  border-bottom: 1px solid gray;
}

.sch_btn_class,
.sch_btn_event {
  padding: 0 35px !important;
}

.logTable tbody tr:hover {
  transform: scale(1) !important;
  -webkit-transform: scale(1) !important;
  -moz-transform: scale(1) !important;
  box-shadow: 0px 0px 5px 2px rgba(13, 84, 139, 0.3) !important;
  -webkit-box-shadow: 0px 0px 5px 2px rgba(13, 84, 139, 0.3) !important;
  -moz-box-shadow: 0px 0px 5px 2px rgba(13, 84, 139, 0.3) !important;
  z-index: 1;
}

.download-button {
  background-color: rgba(79, 174, 175, 0.1);
  color: #112A46;
  border: 1px solid #4FAEAF;
  min-width: 36px !important;
}
</style>
  